import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { map } from 'rxjs/operators';
import { GeneralService } from 'src/app/service/general.service';
import { EmployeeAgreementDocumentAgencyBO, EmployeeDocumentBO } from './employee-agreementlist.model';

@Injectable({
  providedIn: 'root'
})
export class employeeAgreementlistGridService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService) {
    super();
  }

  public exceuteAgreementEmployee(state: EmployeeAgreementDocumentAgencyBO): void {
    this.getOnboardData(state).subscribe(x => super.next(x));
  }
  getOnboardData(state?:EmployeeAgreementDocumentAgencyBO ): Observable<DataStateChangeEventArgs> {  
   return this.http.post<any>("api/EmployeeAgreement/GetEmployeeDocumentListForAgency", state)
      .pipe(map(
        (response: any) =>                    
          <any>{
            result: response['result'],
            count: response['pageCount']
          }
      ))

  }

  public exceuteAgreementEmployeePortal(state: EmployeeDocumentBO): void {
    this.getOnboardDataPortal(state).subscribe(x => super.next(x));
  }
  getOnboardDataPortal(state?:EmployeeDocumentBO ): Observable<DataStateChangeEventArgs> {  
   return this.http.post<any>("api/Employee_EmployeeAgreement/GetEmployeeDocumentListForEmployeePortal", state)
      .pipe(map(
        (response: any) =>                    
          <any>{
            result: response['result'],
            count: response['pageCount']
          }
      ))
  }

  public exceuteAgreementClientportal(state: EmployeeDocumentBO): void {
    this.getOnboardClientDataPortal(state).subscribe(x => super.next(x));
  }
  getOnboardClientDataPortal(state?:EmployeeDocumentBO ): Observable<DataStateChangeEventArgs> {  
   return this.http.post<any>("api/Employee_EmployeeAgreement/GetEmployeeDocumentListForClientPortal", state)
      .pipe(map(
        (response: any) =>                    
          <any>{
            result: response['result'],
            count: response['pageCount']
          }
      ))

  }

}
